"use strict";
/**
 * Sale Popup
 * Opens the promotional popup rendered by sections/sale-popup.liquid.
 *
 * The theme's own popup handling lives in theme.js and is wired to the
 * `newsletter-popup` section type, so this drives its own timing and dismissal
 * cookie. It still borrows theme.Modals for the open/close plumbing (overlay,
 * focus trap, escape key, click outside) so the popup behaves like every other
 * modal on the site.
 *
 * Timing mirrors the newsletter popup: a delay before showing, and a cookie so
 * a dismissed popup stays dismissed for the configured number of days. Test
 * mode skips the cookie entirely so it can be previewed repeatedly.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var SELECTOR = '[data-sale-popup]';
var COOKIE_VALUE = 'opened';
var inEditor = typeof Shopify !== 'undefined' && !!(Shopify === null || Shopify === void 0 ? void 0 : Shopify.designMode);
// Only ever one sale popup on a page — it is a static section rendered once in
// theme.liquid. Holding the live instance here keeps the theme editor handlers
// pointed at the current markup rather than a copy left over from a re-render.
var current = null;
function hasCookie(name) {
    return document.cookie
        .split(';')
        .some(function (cookie) { return cookie.trim().indexOf(name + "=") === 0; });
}
function setCookie(name, days) {
    var expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = name + "=" + COOKIE_VALUE + ";path=/;expires=" + expires;
}
function init(container) {
    var _a;
    var sectionId = (_a = container.dataset.sectionId) !== null && _a !== void 0 ? _a : '';
    var cookieName = "sale-popup-" + sectionId;
    var testMode = container.dataset.testMode === 'true';
    var seconds = Number(container.dataset.delaySeconds) || 5;
    var days = Number(container.dataset.delayDays) || 2;
    var modal = new theme.Modals(container.id, 'sale-popup');
    current = { sectionId: sectionId, modal: modal };
    document.addEventListener("modalClose." + container.id, function () {
        // Test mode is for previewing, so it never marks the popup as seen
        if (testMode || inEditor)
            return;
        setCookie(cookieName, days);
    });
    // In the editor the popup is opened by the section handlers below instead of
    // on a timer, so it never covers the page the merchant is working on.
    if (inEditor)
        return;
    if (!testMode && hasCookie(cookieName))
        return;
    window.setTimeout(function () { return modal.open(); }, seconds * 1000);
}
function sectionIdFrom(evt) {
    var _a;
    return (_a = evt.detail) === null || _a === void 0 ? void 0 : _a.sectionId;
}
function salePopup() {
    var container = document.querySelector(SELECTOR);
    if (container)
        init(container);
    // Section events only fire in the theme editor
    document.addEventListener('shopify:section:load', function (evt) {
        var target = evt.target;
        var reloaded = target === null || target === void 0 ? void 0 : target.querySelector(SELECTOR);
        if (!reloaded)
            return;
        init(reloaded);
        current === null || current === void 0 ? void 0 : current.modal.open();
    });
    document.addEventListener('shopify:section:select', function (evt) {
        if (!current || sectionIdFrom(evt) !== current.sectionId)
            return;
        current.modal.open();
    });
    document.addEventListener('shopify:section:deselect', function (evt) {
        if (!current || sectionIdFrom(evt) !== current.sectionId)
            return;
        current.modal.close();
    });
}
exports.default = salePopup;
